<template>
  <el-dialog
    :destroy-on-close="true"
    title="编辑备注"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    width="500px"
    class="edit-remark-dialog"
  >
    <el-form :model="form" ref="formRef" label-width="80px">
      <el-form-item label="项目ID">
        <el-input v-model="form.projectId" disabled></el-input>
      </el-form-item>
      <el-form-item label="备注内容" prop="remark">
        <el-input
          v-model="form.remark"
          type="textarea"
          :rows="5"
          placeholder="请输入备注内容"
          maxlength="500"
          show-word-limit
          :autosize="{ minRows: 4, maxRows: 8 }"
        ></el-input>
      </el-form-item>
    </el-form>

    <div class="tips-container">
      <i class="el-icon-info"></i>
      <span>备注信息将用于项目内部记录，方便团队协作</span>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="handleSubmit">
        保 存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { requestProjectEditRemark } from "../api/project";

export default {
  name: "EditRemarkDialog",
  props: {
    // 是否显示弹窗
    showDialog: {
      type: Boolean,
      default: false
    },
    // 选中的项目详情
    selectDetail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      form: {
        projectId: "",
        remark: ""
      }
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit("update:showDialog", val);
      }
    }
  },
  watch: {
    selectDetail: {
      handler(newVal) {
        if (newVal) {
          this.form.projectId = newVal.projectId || newVal.id || "";
          this.form.remark = newVal.remark || "";
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.form.remark = "";
      this.$emit("update:showDialog", false);
      this.$emit("close");
    },
    // 提交表单
    async handleSubmit() {
      try {
        this.loading = true;

        const submitData = {
          remark: this.form.remark
        };

        const res = await requestProjectEditRemark(this.form.projectId, submitData);
        if (res?.code === 200) {
          this.$message.success("备注保存成功");
          this.$emit("submit", {
            projectId: this.form.projectId,
            ...submitData
          });
          this.handleClose();
        } else {
          this.$message.error(res?.message || "保存失败");
        }
      } catch (error) {
        console.error("编辑备注失败:", error);
        this.$message.error("操作失败，请重试");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.edit-remark-dialog /deep/ .el-dialog__body {
  padding: 20px 30px;
}

.edit-remark-dialog /deep/ .el-textarea__inner {
  font-size: 14px;
  line-height: 1.6;
}

.tips-container {
  background-color: #f4f4f5;
  border-radius: 4px;
  padding: 10px 15px;
  margin-top: 10px;
  color: #909399;
  font-size: 13px;
  display: flex;
  align-items: center;
}

.tips-container i {
  margin-right: 8px;
  color: #909399;
}

.dialog-footer {
  text-align: right;
}
</style>
